import { render, staticRenderFns } from "./FilterSalesDropdown.vue?vue&type=template&id=b6b2a7a4&"
import script from "./FilterSalesDropdown.vue?vue&type=script&lang=js&"
export * from "./FilterSalesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports